import React from 'react';
import Form from 'react-bootstrap/Form';
import Styles from './Publish.module.scss';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

const SOCIAL_LOGOS = {
  facebook: '/Images/logo-facebook.png',
  linkedin: '/Images/logo-linkedin.png',
  x: '/Images/logo-x.png',
  instagram: '/Images/InstagramLogo.svg',
  tiktok: '/Images/TikTokScript.svg',
};

const IntegrationCard = ({
  integration,
  handleActive,
  handleUpdate,
  handleDelete,
}) => {
  const logoSrc = integration.category === 'social' && SOCIAL_LOGOS[integration.key]
    ? SOCIAL_LOGOS[integration.key]
    : `/Images/${integration.type}.svg`;

  const renderSocialDetails = () => {
    const data = integration?.integration_data;
    const dataType = data?.type;

    if (dataType === 'instagram_business') {
      return (
        <>
          <ul className={Styles.detail_list}>
            <li className={Styles.list_detail_item}>Account</li>
            <li className={Styles.list_name_item}>
              <small>@{data?.username}</small>
            </li>
          </ul>
          <ul className={Styles.detail_list}>
            <li className={Styles.list_detail_item}>Followers</li>
            <li className={Styles.list_name_item}>
              <small>{data?.followers_count?.toLocaleString()}</small>
            </li>
          </ul>
        </>
      );
    }

    if (dataType === 'tiktok') {
      return (
        <>
          <ul className={Styles.detail_list}>
            <li className={Styles.list_detail_item}>Account</li>
            <li className={Styles.list_name_item}>
              <small>{data?.display_name || data?.username || 'TikTok Account'}</small>
            </li>
          </ul>
          <ul className={Styles.detail_list}>
            <li className={Styles.list_detail_item}>Followers</li>
            <li className={Styles.list_name_item}>
              <small>{data?.followers_count?.toLocaleString() || '—'}</small>
            </li>
          </ul>
        </>
      );
    }

    if (dataType === 'page') {
      return (
        <>
          <ul className={Styles.detail_list}>
            <li className={Styles.list_detail_item}>Page's name</li>
            <li className={Styles.list_name_item}>
              <small>{data?.page_name}</small>
            </li>
          </ul>
          <ul className={Styles.detail_list}>
            <li className={Styles.list_detail_item}>Page's category</li>
            <li className={Styles.list_name_item}>
              <small>{data?.category}</small>
            </li>
          </ul>
        </>
      );
    }

    // Default: LinkedIn personal, X, etc.
    return (
      <>
        <ul className={Styles.detail_list}>
          <li className={Styles.list_detail_item}>User's name</li>
          <li className={Styles.list_name_item}>
            {data?.first_name} {data?.last_name}
          </li>
        </ul>
        <ul className={Styles.detail_list}>
          <li className={Styles.list_detail_item}>
            {data?.twitter_handle || data?.screen_name ? 'Handle' : "User's email"}
          </li>
          <li className={Styles.list_name_item}>
            {data?.twitter_handle
              ? `@${data.twitter_handle}`
              : data?.screen_name
              ? `@${data.screen_name}`
              : data?.email}
          </li>
        </ul>
      </>
    );
  };

  return (
    <div className={Styles.publish_container_new}>
      <div className={Styles.main_channel_container}>
        <div className={Styles.card_channel}>
          <div className={Styles.d_flex_channel_logo_box}>
            <div className={Styles.channel_logo_name}>
              <div className={Styles.channel_logo}>
                <img src={logoSrc} alt={integration?.name} />
              </div>
              <p className={Styles.logo_name}>{integration?.name}</p>
            </div>

            <DropdownButton
              title={<BsThreeDotsVertical color="#182230" />}
            >
              {integration.category !== 'social' && (
                <Dropdown.Item onClick={() => handleUpdate(integration)}>
                  <div className={Styles.DropdownItem}>
                    <FiEdit size={14} />
                    <p className={Styles.DropdownItem_Text}>Edit</p>
                  </div>
                </Dropdown.Item>
              )}

              <Dropdown.Item onClick={() => handleDelete(integration)}>
                <div className={Styles.DropdownItem}>
                  <FiTrash2 size={14} />
                  <p className={Styles.DropdownItem_Text}>Delete</p>
                </div>
              </Dropdown.Item>
            </DropdownButton>
          </div>
          <div className={Styles.detail_section}>
            {integration.category === 'social' ? (
              renderSocialDetails()
            ) : (
              <>
                <ul className={Styles.detail_list}>
                  <li className={Styles.list_detail_item}>Integration</li>
                  <li className={Styles.list_name_item}>
                    {integration?.account}
                  </li>
                </ul>
                <ul className={Styles.detail_list}>
                  <li className={Styles.list_detail_item}>Website</li>
                  <li className={Styles.list_name_item}>
                    {integration?.site_identification}
                  </li>
                </ul>
              </>
            )}
          </div>
          <div className={Styles.active_section}>
            <p className={Styles.active_status}>Active:</p>
            <p className={Styles.active_status}>
              <div
                className={`${Styles.cylinderToggle} ${integration.is_active ? Styles.active : ''}`}
                onClick={() => handleActive(integration)}
              >
                <Form>
                  <Form.Check
                    type="switch"
                    className={Styles.cylinderToggle__switch}
                    checked={integration.is_active}
                    onChange={(e) => {
                      handleActive(integration);
                    }}
                  />
                </Form>
              </div>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationCard;
